import { useState, useEffect, useCallback } from "react";
import { Api } from "../request/api/api";
import { XpSourceDict, CreateXpSourceDto } from "../model/Dto/Dict/XpSource";

export function useXpSourceDict() {
    const [xpSources, setXpSources] = useState<XpSourceDict[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchXpSources = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.getAllXpSources();
            setXpSources(result);
        } catch (err) {
            setError("Ошибка загрузки источников опыта");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const createXpSource = useCallback(async (data: CreateXpSourceDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createXpSource(data);
            if (result) { await fetchXpSources(); return true; }
            setError("Ошибка создания источника опыта");
            return false;
        } catch (err) {
            setError("Ошибка создания источника опыта");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchXpSources]);

    const updateXpSource = useCallback(async (id: string, data: CreateXpSourceDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateXpSource(id, data);
            if (result) { await fetchXpSources(); return true; }
            setError("Ошибка обновления источника опыта");
            return false;
        } catch (err) {
            setError("Ошибка обновления источника опыта");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchXpSources]);

    const deleteXpSource = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteXpSource(id);
            if (result) { await fetchXpSources(); return true; }
            setError("Ошибка удаления источника опыта");
            return false;
        } catch (err) {
            setError("Ошибка удаления источника опыта");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchXpSources]);

    useEffect(() => {
        fetchXpSources();
    }, [fetchXpSources]);

    return { xpSources, loading, error, createXpSource, updateXpSource, deleteXpSource, refetch: fetchXpSources };
}
